import {
  Input,
  Select,
  Radio,
  Button,
  DatePicker,
  TimePicker,
  TreeSelect,
  Cascader,
  Tree,
  Upload,
  Checkbox,
} from "antd";
import ReactQuill from "react-quill";
import type { FormItemProps } from "antd";
import "dayjs/locale/zh-cn";
import locale from "antd/es/date-picker/locale/zh_CN";
import dayjs from "dayjs";
import { getFirstDay, getTimeFormat } from "@/utils/common";

const { RangePicker } = DatePicker;
const { TextArea } = Input;

const quillModules = {
  toolbar: {
    container: [
      ["bold", "italic", "underline", "strike"],
      ["blockquote", "code-block"],
      [{ header: 1 }, { header: 2 }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ script: "sub" }, { script: "super" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ direction: "rtl" }],
      [{ size: ["small", false, "large", "huge"] }],
      [{ color: [] }],
      [{ background: [] }],
      [{ font: [] }],
      [{ align: [] }],
      ["link", "image",],
    ],
  },
};

interface FormTabItem extends FormItemProps {
  type: string;
  width?: string;
  options?: any[];
  params?: Record<string, any>;
  notShow?: Boolean;
  showCondition?: string;
  defaultValues?: any[];
}



export const setType = (item: FormTabItem, initialValues?: Record<string, any>, defaultTimer?: any, onDateClear?: () => void) => {
  
  const convertedDefaultTimer = Array.isArray(defaultTimer)
  ? defaultTimer.map(dateStr => dayjs(dateStr, 'YYYY-MM-DD'))
  : [];

  switch (item.type) {
    case "text":
      return <span {...item.params}>{item.params?.text || ""}</span>;
    case "input":
      return (
        <Input placeholder={"请输入" + item.label} {...item.params}></Input>
      );
    case "select":
      return (
        <Select
          placeholder="请选择"
          options={item.options?.length ? item.options : undefined}
          allowClear
          {...item.params}
        ></Select>
      );
    case "radio":
      return (
        <Radio.Group options={item.options} {...item.params}></Radio.Group>
      );
    case "button":
      return <Button {...item.params}>{item.name}</Button>;
    case "datePicker":
      return (
        <DatePicker
          locale={locale}
          format="YYYY-MM-DD"
          {...item.params}
        ></DatePicker>
      );
    case "rangePicker":
      return (
        <RangePicker
          locale={locale}
          format="YYYY-MM-DD"
          {...item.params}
          onChange={(dates) => {
            if (!dates || !dates[0]) {
              onDateClear && onDateClear();
            }
            item.params?.onChange && item.params.onChange(dates);
          }}
        ></RangePicker>
      );
    case "timePicker":
      return <TimePicker format="HH:mm:ss" {...item.params} ></TimePicker>;
    case "textArea":
      return <TextArea placeholder="请输入" {...item.params}></TextArea>;
    case "treeSelect":
      return <TreeSelect {...item.params}></TreeSelect>;
    case "cascader":
      return <Cascader placeholder="请选择" options={item.options || []} {...item.params}></Cascader>;
    case "quill":
      return (
        <ReactQuill
          modules={quillModules}
          placeholder="请输入"
          style={{
            width: item?.params?.width || "800px",
            minHeight: "300px",
          }}
          {...item.params}
        ></ReactQuill>
      );
    case "tree":
      return (
        <div
          style={{
            border: "1px solid #efefef",
            borderRadius: "4px",
            padding: "6px",
          }}
        >
          <Tree {...item.params}></Tree>
        </div>
      );
    case "upload":
      return (
        <Upload listType="picture-card" accept="image/*" {...item.params}>
          {initialValues?.[item.name as any]?.length <
          (item?.params?.maxCount as number)
            ? item.params?.uploadMessage
            : null}
        </Upload>
      );
    case "checkboxGroup":
      return (
        <Checkbox.Group options={item.options} {...item.params} />
      );
    default:
      break;
  }
};
